function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7378 5.33334C28.6166 5.32085 28.4945 5.32085 28.3733 5.33334H3.48442C3.3249 5.3358 3.16644 5.35971 3.01331 5.40445L15.8577 18.1956L28.7378 5.33334Z",
  fill: "#F3F3F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.0534 6.56885L17.1111 19.4577C16.778 19.7888 16.3275 19.9747 15.8578 19.9747C15.3881 19.9747 14.9376 19.7888 14.6045 19.4577L1.7778 6.66663C1.73837 6.81155 1.71746 6.96089 1.71558 7.11107V24.8888C1.71558 25.3603 1.90288 25.8125 2.23628 26.1459C2.56967 26.4793 3.02186 26.6666 3.49335 26.6666H28.3822C28.8537 26.6666 29.3059 26.4793 29.6393 26.1459C29.9727 25.8125 30.16 25.3603 30.16 24.8888V7.11107C30.1529 6.92587 30.117 6.74292 30.0534 6.56885ZM4.71113 24.8888H3.47558V23.6177L9.9378 17.2088L11.1911 18.4622L4.71113 24.8888ZM28.3645 24.8888H27.12L20.64 18.4622L21.8934 17.2088L28.3556 23.6177L28.3645 24.8888Z",
  fill: "#F3F3F3"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.d1879350.svg";
export { ForwardRef as ReactComponent };